import {FC} from 'react';
import {
    ProjectContainerLayoutLeftWrapper,
    ProjectContainerLayoutRightWrapper,
    ProjectContainerLayoutWrapper,
    ProjectContainerLayoutWrapperOuter,
} from './project-container-layout.styles';
import {FlexBoxProps} from '@brg/ui';
import { AppTester } from 'supporting';
import { useSelector } from "react-redux";
import NavigateBackButton from 'core/components/NavigateBackButton';
import { useHistory } from 'react-router-dom';

/**
 * Project container layout props
 */
export interface ProjectContainerLayoutProps {
    rightSide: JSX.Element;
    leftSide: JSX.Element;
    header?: JSX.Element;
    footer?: JSX.Element;
    flex?: FlexBoxProps;
    className?: any;
    isProjectEdit?: boolean;
    mobileCoverControls?: boolean;
    isProjectPage?: boolean;
    isBookMainPage?: boolean;
    isBookEdit?: boolean;
    isCompetitionEdit?: boolean;
    isCollectionVote?: boolean;
}

/**
 * Projects container layout
 * @param rightSide
 * @param leftSide
 * @param header
 * @param flex
 * @constructor
 */
export const ProjectContainerLayout: FC<ProjectContainerLayoutProps> = ({
    rightSide,
    leftSide,
    flex,
    header,
    footer,
    isProjectEdit,
    mobileCoverControls,
    isProjectPage,
    isBookMainPage,
    isBookEdit,
    isCompetitionEdit,
    isCollectionVote
}) => {
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isMediiia = AppTester.isMediiia();
    const vtype = useSelector((state: any) => state.vt.vtype);
    const skipReducedVersion = ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(vtype);
    const isBooks = AppTester.isBooks();
    const history = useHistory();
    return (
        <ProjectContainerLayoutWrapperOuter
          isCompetitionEdit={isCompetitionEdit}
          isBookMainPage={isBookMainPage}
          isBookEdit={isBookEdit}
          isProjectEdit={isProjectEdit}
          skipReducedVersion={skipReducedVersion}
        >
            {header}
            {isCollectionVote && <NavigateBackButton text="все игры" hasOffset backPath={() => isMediiia ? history.push('/game') : history.push('/')}/>}
            <ProjectContainerLayoutWrapper {...flex}
                                           isCompetitionEdit={isCompetitionEdit}
                                           isProjectEdit={isProjectEdit}
                                           isProjectPage={isProjectPage}
                                           isBookMainPage={isBookMainPage}
                                           isBookEdit={isBookEdit}
                                           skipReducedVersion={skipReducedVersion}
                                           isBooks={isBooks}
            >
                <ProjectContainerLayoutLeftWrapper $mobileCoverControls={mobileCoverControls} isCompetitionEdit={isCompetitionEdit} isAgeytomesh={isAgeytomesh} isProjectEdit={isProjectEdit} isProjectPage={isProjectPage} isBookMainPage={isBookMainPage} isBookEdit={isBookEdit}>{leftSide}</ProjectContainerLayoutLeftWrapper>
                <ProjectContainerLayoutRightWrapper isCompetitionEdit={isCompetitionEdit} isProjectEdit={isProjectEdit} isProjectPage={isProjectPage} isBookMainPage={isBookMainPage} isBookEdit={isBookEdit}>{rightSide}</ProjectContainerLayoutRightWrapper>
            </ProjectContainerLayoutWrapper>
            {footer}
        </ProjectContainerLayoutWrapperOuter>
    );
};
import {FC} from 'react';
import {
    ProjectContainerLayoutLeftWrapper,
    ProjectContainerLayoutRightWrapper,
    ProjectContainerLayoutWrapper,
    ProjectContainerLayoutWrapperOuter,
} from './project-container-layout.styles';
import {FlexBoxProps} from '@brg/ui';
import { AppTester } from 'supporting';
import { useSelector } from "react-redux";
import NavigateBackButton from 'core/components/NavigateBackButton';
import { useHistory } from 'react-router-dom';

/**
 * Project container layout props
 */
export interface ProjectContainerLayoutProps {
    rightSide: JSX.Element;
    leftSide: JSX.Element;
    header?: JSX.Element;
    footer?: JSX.Element;
    flex?: FlexBoxProps;
    className?: any;
    isProjectEdit?: boolean;
    mobileCoverControls?: boolean;
    isProjectPage?: boolean;
    isBookMainPage?: boolean;
    isBookEdit?: boolean;
    isCompetitionEdit?: boolean;
    isCollectionVote?: boolean;
}

/**
 * Projects container layout
 * @param rightSide
 * @param leftSide
 * @param header
 * @param flex
 * @constructor
 */
export const ProjectContainerLayout: FC<ProjectContainerLayoutProps> = ({
    rightSide,
    leftSide,
    flex,
    header,
    footer,
    isProjectEdit,
    mobileCoverControls,
    isProjectPage,
    isBookMainPage,
    isBookEdit,
    isCompetitionEdit,
    isCollectionVote
}) => {
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isMediiia = AppTester.isMediiia();
    const vtype = useSelector((state: any) => state.vt.vtype);
    const skipReducedVersion = ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(vtype);
    const isBooks = AppTester.isBooks();
    const history = useHistory();
    return (
        <ProjectContainerLayoutWrapperOuter
          isCompetitionEdit={isCompetitionEdit}
          isBookMainPage={isBookMainPage}
          isBookEdit={isBookEdit}
          isProjectEdit={isProjectEdit}
          skipReducedVersion={skipReducedVersion}
        >
            {header}
            {isCollectionVote && <NavigateBackButton text="все игры" hasOffset backPath={() => isMediiia ? history.push('/game') : history.push('/')}/>}
            <ProjectContainerLayoutWrapper {...flex}
                                           isCompetitionEdit={isCompetitionEdit}
                                           isProjectEdit={isProjectEdit}
                                           isProjectPage={isProjectPage}
                                           isBookMainPage={isBookMainPage}
                                           isBookEdit={isBookEdit}
                                           skipReducedVersion={skipReducedVersion}
                                           isBooks={isBooks}
            >
                <ProjectContainerLayoutLeftWrapper $mobileCoverControls={mobileCoverControls} isCompetitionEdit={isCompetitionEdit} isAgeytomesh={isAgeytomesh} isProjectEdit={isProjectEdit} isProjectPage={isProjectPage} isBookMainPage={isBookMainPage} isBookEdit={isBookEdit}>{leftSide}</ProjectContainerLayoutLeftWrapper>
                <ProjectContainerLayoutRightWrapper isCompetitionEdit={isCompetitionEdit} isProjectEdit={isProjectEdit} isProjectPage={isProjectPage} isBookMainPage={isBookMainPage} isBookEdit={isBookEdit}>{rightSide}</ProjectContainerLayoutRightWrapper>
            </ProjectContainerLayoutWrapper>
            {footer}
        </ProjectContainerLayoutWrapperOuter>
    );
};
